export const environment = {
  production: true,
  apiUrl: 'https://producerportal-api-test.anzcofoods.com',
  webUrl: 'https://producerportal-test.anzcofoods.com',
  releaseVersion: 'BuildNo Test: 20260707.1',
  advantageUrl: 'https://anzcoadvantage-uat.ichange360.com',
  raygunKey: 'lkC2S9XF4xQOBV4ZPTwBzg',
};
